import React, { Component } from "react";
import firebase from "../Firebase";
import parse from 'html-react-parser';
import { ReactComponent as Info } from "../img/svg/info.svg";
class Message extends Component {
constructor(props) {
super(props);
this.ref = firebase.firestore().collection("content")
.where("page", "==", "message");
this.unsubscribe = null;
this.state = {
boards: [],
messageToggle:"true",
};

}
onCollectionUpdate = (querySnapshot) => {
const boards = [];
querySnapshot.forEach((doc) => {
const {
title,
status,
page,
content,

} = doc.data();
boards.push({
key: doc.id,
doc, // DocumentSnapshot
title,
status,
page,
content,
});

});
this.setState({
boards,
});
};

closeMessage = value => () => {
const state = this.state;
state.messageToggle = value;
this.setState(state);
};
componentDidMount() {
this.unsubscribe = this.ref.onSnapshot(this.onCollectionUpdate);
}
render() {
return (
<>
	{this.state.messageToggle ==="true" ?
	<div>
		{this.state.boards.map((board) => (
		<>
			{board.status ==="1" ?
			<div className="message-1" onClick={this.closeMessage("false")}>

				<div className="col-2">
					<div>
						<Info className="info-icon" />
					</div>

					<div> <span>
							<h2>{board.title}</h2>
							<p>{parse(board.content)}</p>
							<button className="button-small" onClick={this.closeMessage("false")}>Close</button>
						</span> </div>

				</div>
			</div>
			: null}
			{board.status ==="2" ?
			<div className="message-2" onClick={this.closeMessage("false")}>
				<div className="col-2">
					<div>
						<Info className="info-icon" />
					</div>
					<div> <span>
							<h2>{board.title}</h2>
							<p>{parse(board.content)}</p>
							<button className="button-small" onClick={this.closeMessage("false")}>Close</button>
						</span> </div>
				</div>
			</div>
			: null}
			{board.status ==="3" ?
			<div className="message-3" onClick={this.closeMessage("false")}>
				<div className="col-2">
					<div>
						<Info className="info-icon" />
					</div>
					<div> <span>
							<h2>{board.title}</h2>
							<p>{parse(board.content)}</p>
							<button className="button-small" onClick={this.closeMessage("false")}>Close</button>
						</span> </div>
				</div>

			</div>
			: null}


		</>
		))}

	</div>
	: null}
</>
);
}
}

export default Message;
